<bic-popup [title]="title" (close)="cancelClicked()" customClass="w-[560px]">
  <div bicPopupContent>
    <span class="text-sm">{{ message }}</span>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="deleteClicked()" buttonType="red">Löschen</bic-button>
  </div>
</bic-popup>
